<!--
 * @Author: your name
 * @Date: 2022-06-22 10
-->
<template>
  <div class="bg">
    <div class="maintain"><img src="~@/assets/icon/home/feedback_banner.jpg" alt=""></div>
    <second-title
      letter="W"
      enTitle="arranty coverage"
      current_add="保修范围"
      add_one="首页"
      add_tow="无极服务"
      add_three="保修范围"
    >
    </second-title>
    <div>
      <particulars-navigation
        en_title="WARRANTY COVERAGE"
        ch_title_name="保修"
        ch_title_text="范围"
        class="animate__animated animate__zoomIn"
      ></particulars-navigation>
      <div class="warranty_text animate__animated animate__slideInUp">若您的爱车在质保期内出现相关问题，VOGE售后服务会为您及时清除障碍，祝您尽享驾驶乐趣，您可在以下表格了解VOGE提供的保修范围。</div>
      <div class="warranty_details">
        <div class="warranty_details_title animate__animated animate__zoomIn">发动机</div>
        <div class="warranty_table animate__animated animate__slideInUp">
          <table>
            <tr>
              <th colspan="2">
                <div>VOGE无极系列车型三包服务范围 (注册用户)</div>
              </th>
              <th colspan="2">
                <div class="td2">VOGE无极车型 (赠送延保服务车型除外)</div>
              </th>
            </tr>
            <tr>
              <th>
                <div class="td1">归属</div>
              </th>
              <th>
                <div class="td2">零件名称</div>
              </th>
              <th colspan="2">
                <div >三包有效期</div>
              </th>
            </tr>
            <tr v-for="(item,index) in tableDataEngine" :key="index">
              <td>{{item.affiliation}}</td>
              <td>{{item.designation}}</td>
              <td>{{item.content}}</td>
            </tr>
          </table>
        </div>
        <div class="warranty_details_title" ref="motorcycle" :class="{'animate__animated animate__zoomIn':showMotorcycle}">整车</div>
        <div class="warranty_table" :class="{'animate__animated animate__slideInUp':showMotorcycle}">
          <table>
            <tr>
              <th colspan="2">
                <div >VOGE无极系列车型三包服务范围 (注册用户)</div>
              </th>
              <th colspan="2">
                <div class="td2">VOGE无极车型 (赠送延保服务车型除外)</div>
              </th>
            </tr>
            <tr>
              <th>
                <div class="td1">归属</div>
              </th>
              <th>
                <div class="td2">零件名称</div>
              </th>
              <th colspan="2">
                <div >三包有效期</div>
              </th>
            </tr>
            <tr v-for="(item,index) in tableDataCar" :key="index">
              <td>{{item.affiliation}}</td>
              <td>{{item.designation}}</td>
              <td>{{item.content}}</td>
            </tr>
          </table>
        </div>
        <div class="warranty_details_title" ref="other" :class="{'animate__animated animate__zoomIn':showOther}">其他</div>
        <div class="warranty_table" :class="{'animate__animated animate__slideInUp':showOther}">
          <table>
            <tr>
              <th colspan="2">
                <div >VOGE无极系列车型三包服务范围 (注册用户)</div>
              </th>
              <th colspan="2">
                <div class="td2">VOGE无极车型 (赠送延保服务车型除外)</div>
              </th>
            </tr>
            <tr>
              <th>
                <div class="td1">归属</div>
              </th>
              <th>
                <div class="td2">零件名称</div>
              </th>
              <th colspan="2">
                <div>三包有效期</div>
              </th>
            </tr>
            <tr v-for="(item,index) in tableDataOther" :key="index">
              <td>{{item.affiliation}}</td>
              <td>{{item.designation}}</td>
              <td>{{item.content}}</td>
            </tr>
          </table>
        </div>

        <div class="warranty_details_title" ref="ysyh" :class="{'animate__animated animate__zoomIn':showYsYh}">易损、易耗件</div>
        <div class="warranty_table" :class="{'animate__animated animate__slideInUp':showYsYh}">
          <table>
            <tr>
              <th colspan="2">
                <div >VOGE无极系列车型三包服务范围 (注册用户)</div>
              </th>
              <th colspan="2">
                <div class="td2">VOGE无极车型 (赠送延保服务车型除外)</div>
              </th>
            </tr>
            <tr>
              <th colspan="2">
                <div class="td2">零件名称</div>
              </th>
              <th colspan="2">
                <div>三包有效期</div>
              </th>
            </tr>
            <tr v-for="(item,index) in tableDataYsYh" :key="index">
              <td colspan="2">{{item.designation}}</td>
              <td colspan="2">{{item.content}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <base-footers></base-footers>
  </div>
</template>
<script>
import SecondTitle from '@/components/SecondTitle';
import Footers from "@/components/Footers.vue";
import ParticularsNavigation from "@/components/ParticularsNavigation.vue";
export default {
  components:{
    SecondTitle,
    ParticularsNavigation,
    BaseFooters:Footers,
  },
  data(){
    return{
      showMotorcycle:false,
      showOther:false,
      showYsYh: false,
      tableDataEngine: [
        {
          classification:'发动机',
          affiliation: '曲轴箱体部分',
          designation: '左曲轴箱体、右曲轴箱体、左过渡箱体',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '曲轴部分',
          designation: '曲柄连杆部件',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '磁电机组件',
          designation: '转子部件、锭子部件',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '离合器组件',
          designation: '离合器外罩组合、离合器中心套（不含摩擦片）',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '气缸头部件',
          designation: '气缸头（ 不含气缸头盖 ）、气缸体、凸轮轴支架',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '活塞总成',
          designation: '活塞、活塞销',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '配气机构',
          designation: '气门挺柱、气门调整垫片、气门弹簧、进气门、排气门、正时从动轮',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '变速机构',
          designation: '变速鼓、五星拨板、拨叉、拨叉轴',
          content: '两年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'发动机',
          affiliation: '传动机构',
          designation: '传动主轴、传动副轴、输出轴',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '平衡轴部分',
          designation: '平衡轴齿轮副、平衡轴',
          content: '两年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'发动机',
          affiliation: '起动电机部件',
          designation: '起动电机部件',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '机油泵总成',
          designation: '机油泵转子组合、油泵传动轴',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'发动机',
          affiliation: '配气机构',
          designation: '正时链条',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
      ],
      tableDataCar: [
        {
          classification:'整车',
          affiliation: '操控部分',
          designation: '方向柱总成、上连板',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '机架部分',
          designation: '平叉、车架',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶制动部分',
          designation: '前、后轮圈',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '电气部分',
          designation: '主电缆',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '辅助部分',
          designation: '后护手、机油箱',
          content: '两年（不限里程）',
          content1:'五年或8万公里'
        },
        {
          classification:'整车',
          affiliation: '电喷系统',
          designation: '节气阀体、电喷点火程序控制器（ECU）、氧传感器、进气温度压力传感器、节气门位置传感器、怠速控制阀、水温传感器、燃油蒸发控制组件',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '电器部分',
          designation: '闸把开关、高压包、全车锁、风扇组件、仪表组件、燃油泵、DC插座、USB、蜂鸣器、车载T-BOX、行车记录仪、摄像头',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '排气系统',
          designation: '消声器体后段、排气管',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '行驶部分',
          designation: '前后减震器',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '外包围部分',
          designation: '冷却水箱、坐垫',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        },
        {
          classification:'整车',
          affiliation: '外观部分',
          designation: '油箱',
          content: '一年（不限里程）',
          content1:'三年2万公里'
        }
      ],
      tableDataOther: [
        {
          classification:'其他',
          affiliation: '关重部件',
          designation: '曲柄连杆组件、主轴、副轴、气门锁夹、活塞销、机油滤清器、左曲轴箱盖，右 曲轴箱盖，机油泵、上摇臂组件、进/排气门、气门内外弹簧、凸轮轴随动器轴、 凸轮轴芯、压销体、拨叉轴、主动齿轮、气门顶杆、凸轮减压机构组合、进排气摇臂组合、车架、平叉',
          content: '一年或6000公里',
          content1:'一年或6000公里'
        },
        {
          classification:'其他',
          affiliation: '发动机零部件',
          designation: '气缸盖、气门、气缸头、气门锁夹、气门弹簧、气门摇臂、气门挺杆、簧片阀、气 缸盖螺栓、止动板组件、止动板弹簧、缸体、曲轴箱、正时齿轮、正时链条、左右 曲轴箱盖、活塞、活塞销、连杆、曲轴、曲柄销、曲轴主轴承、正时齿（链） 轮、 凸轮轴凸轮、凸轮轴轴承、凸轮轴齿（链） 轮、机油泵、磁电机充电线圈、磁电机 线圈、点火线圈、转子、离合器、离合器齿轮、离合器传动链条、变速鼓、变速   轴、变速齿轮、变速拨叉、输出链轮轴、输出链轮、主副轴齿轮、主副轴轴承、超 越离合器、链盘、启动电机、启动齿、中间轴齿轮、CVT系统',
          content: '六个月或3000公里',
          content1:'六个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '摩托车零件',
          designation: '闸把座、座垫、缓冲体本体、三锁、油箱、轮辋、制动器本体、油开关、仪表、高 压包、点火器、调压器、闪光器、继电器、方向柱、化油器、手把管、主站架、全 车电缆、平叉、消声器、车架、前后脚蹬、后扶手、前后减震、方向轴承、灯具、DC插座、USB、蜂鸣器、车载T-BOX、行车记录仪、摄像头',
          content: '六个月或3000公里',
          content1:'六个月或3000公里'
        },
        {
          classification:'其他',
          affiliation: '蓄电池',
          designation: '外壳破裂、漏电解液、极柱断裂 或松脱（属制造原因）',
          content: '一年或6000公里',
          content1:'一年或6000公里'
        },
        {
          classification:'其他',
          affiliation: '蓄电池',
          designation: '不能正常充电、放电、存电、严重硫化',
          content: '6个月或6000公里',
          content1:'6个月或6000公里'
        },
        {
          classification:'其他',
          affiliation: '镀铬件',
          designation: '（消声器、货架、踏板、网轮、 保险杠、手把管等）出现脱铬、起皮',
          content: '一年或6000公里',
          content1:'一年或6000公里'
        },
        {
          classification:'其他',
          affiliation: '镀铬件',
          designation: '（消声器、货架、踏板、网轮、 保险杠、手把管等）出现生锈',
          content: '3个月或3000公里',
          content1:'3个月或3000公里'
        },
      ],
      tableDataYsYh: [
        {
          classification:'易损、易耗件',
          designation: '烤漆外观覆盖件（锈蚀、变色、起层、龟裂）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '全车油封（漏油、过度磨损）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '全车轴承（过度磨损、碎裂）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '后视镜（脱落、滑丝、连接松动）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '内外胎（鼓包、起层、老化开裂）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '大小链盘断齿（正常使用状态）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: 'CVT主、从动轮（正常使用状态）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '驱动链条断裂（正常使用状态）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: 'CVT皮带（正常使用状态）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '速度计齿轮（涡轮、涡杆）',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '空滤器（不含滤芯）',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '各种软轴、拉索线芯断裂',
          content: '6个月或行驶6000公里',
          content1:'6个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '防盗器失灵',
          content: '3个月或行驶3000公里',
          content1:'3个月或行驶3000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '正时链条拉长（通过调节不能解决的）',
          content: '1个月或行驶6000公里',
          content1:'1个月或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '正时链条断裂',
          content: '1年或行驶6000公里',
          content1:'1年或行驶6000公里'
        },
        {
          classification:'易损、易耗件',
          designation: '火花塞（裂纹、断裂、烧蚀）',
          content: '3个月或3000公里',
          content1:'3个月或3000公里'
        },
      ]
    }
  },
  mounted(){
    window.addEventListener('scroll',this.handleScroll)
  },
  methods:{
    handleScroll(){
      this.currentScroll = window.scrollY //表示当前滚动的位置
      // 品牌定位
      if ((this.currentScroll > this.$refs.motorcycle.offsetTop-700) && this.$refs.motorcycle.offsetTop != 0) {
          this.showMotorcycle = true
      }
      // 品牌主张
      if ((this.currentScroll > this.$refs.other.offsetTop-700) && this.$refs.other.offsetTop != 0) {
          this.showOther = true
      }
      // 品牌主张
      if ((this.currentScroll > this.$refs.ysyh.offsetTop-700) && this.$refs.ysyh.offsetTop != 0) {
        this.showYsYh = true
      }

    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
